import { z } from "zod";

export type QcBizLocationGroup = z.infer<typeof QcBizLocationGroupSchema>;
export const QcBizLocationGroupSchema = z.object({
  id: z.number(),
  tenant_id: z.number(),
  name: z.string(),
  display_name: z.string(),
  is_default: z.boolean(),
  is_show_chat_history: z.boolean(),
});
